module.exports = __webpack_public_path__ + "assets/fonts/iconfont.1fe1a829.woff2";